module.exports = __webpack_public_path__ + "static/media/orchestra_w_2000.3f131df4.jpg";